var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBackgroundLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 159,
    viewBox: "0 0 558 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2939_1446)",
    filter: "url(#filter0_d_2939_1446)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_2939_1446)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 854.119,
    cy: 135.381,
    r: 294.881,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_f_2939_1446)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 234.881,
    cy: 225.381,
    r: 294.881,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-110.652 -24.6727C-88.6764 -81.638 -94.7957 -116.098 -109.295 -131.113C-123.795 -146.128 -158.02 -153.446 -215.718 -133.472C-270.622 -114.465 -335.74 -73.8225 -396.643 -15.009C-457.547 43.8046 -500.436 107.465 -521.348 161.672C-543.324 218.637 -537.204 253.097 -522.705 268.112C-508.205 283.127 -473.98 290.445 -416.282 270.471C-361.378 251.464 -296.26 210.822 -235.357 152.008C-174.453 93.1946 -131.564 29.5342 -110.652 -24.6727ZM-212.893 175.27C-85.8865 52.6205 -29.0895 -94.6088 -86.0337 -153.576C-142.978 -212.544 -292.1 -160.92 -419.107 -38.2704C-546.113 84.3787 -602.91 231.608 -545.966 290.575C-489.022 349.543 -339.9 297.919 -212.893 175.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1089.35 -24.6727C1111.32 -81.638 1105.2 -116.098 1090.7 -131.113C1076.21 -146.128 1041.98 -153.446 984.282 -133.472C929.378 -114.465 864.26 -73.8225 803.357 -15.009C742.454 43.8046 699.564 107.465 678.652 161.672C656.676 218.637 662.796 253.097 677.295 268.112C691.795 283.127 726.02 290.445 783.718 270.471C838.622 251.464 903.74 210.822 964.643 152.008C1025.55 93.1946 1068.44 29.5342 1089.35 -24.6727ZM987.107 175.27C1114.11 52.6205 1170.91 -94.6088 1113.97 -153.576C1057.02 -212.544 907.9 -160.92 780.894 -38.2704C653.887 84.3787 597.09 231.608 654.034 290.575C710.978 349.543 860.1 297.919 987.107 175.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3461 -22.224C50.1417 -79.782 55.0325 -117.796 72.4392 -135.821C89.8458 -153.847 127.666 -160.061 185.964 -139.879C241.995 -120.482 307.935 -79.2257 369.384 -19.885C430.833 39.4557 474.365 103.916 495.706 159.235C517.91 216.793 513.02 254.808 495.613 272.833C478.206 290.858 440.386 297.072 382.088 276.89C326.057 257.493 260.117 216.237 198.668 156.896C137.219 97.5556 93.6869 33.0957 72.3461 -22.224ZM58.9418 -148.856C33.4022 -122.409 32.0889 -74.4461 54.84 -15.4706C77.3677 42.9259 122.676 109.596 185.634 170.394C248.592 231.191 316.802 274.145 375.95 294.621C435.683 315.3 483.571 312.314 509.11 285.867C534.65 259.42 535.963 211.457 513.212 152.482C490.684 94.0853 445.376 27.4152 382.418 -33.3824C319.46 -94.1799 251.25 -137.134 192.102 -157.61C132.369 -178.289 84.4814 -175.303 58.9418 -148.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.348 -24.6727C511.324 -81.638 505.204 -116.098 490.705 -131.113C476.205 -146.128 441.98 -153.446 384.282 -133.472C329.378 -114.465 264.26 -73.8225 203.357 -15.009C142.454 43.8046 99.5637 107.465 78.6521 161.672C56.6765 218.637 62.7958 253.097 77.2953 268.112C91.7948 283.127 126.02 290.445 183.718 270.471C238.622 251.464 303.74 210.822 364.643 152.008C425.547 93.1946 468.437 29.5342 489.348 -24.6727ZM387.107 175.27C514.114 52.6205 570.911 -94.6088 513.966 -153.576C457.022 -212.544 307.9 -160.92 180.894 -38.2704C53.8867 84.3787 -2.91035 231.608 54.0339 290.575C110.978 349.543 260.1 297.919 387.107 175.27Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2939_1446",
    x: -4,
    y: 0.5,
    width: 566,
    height: 158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2939_1446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2939_1446",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2939_1446",
    x: 281.261,
    y: -437.477,
    width: 1145.72,
    height: 1145.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.989,
    result: "effect1_foregroundBlur_2939_1446"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2939_1446",
    x: -337.977,
    y: -347.477,
    width: 1145.72,
    height: 1145.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.989,
    result: "effect1_foregroundBlur_2939_1446"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2939_1446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 558,
    height: 150,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBackgroundLogo);
export default __webpack_public_path__ + "static/media/accountBackgroundLogo.9e1222b9d966b50cc8f86db5df7cd1f5.svg";
export { ForwardRef as ReactComponent };